export default "__VITE_ASSET__D5N7I0HF__"